import { createSimpleStore } from 'react-simple-reducer'
import { getParceiro, listUsuariosParceiro, getVendas } from './parceirosApi'
import { notification } from 'antd'

interface ParceiroData {
  id?: number
  cpfCnpj?: string
  nome?: string
  telefone?: string
  uf?: string
  createdAt?: string
}

interface UsuarioVinculo {
  usuarioId: number
  role: string
  usuario: { id: number; nome: string; email: string; cpf: string }
}

export interface QsaMember {
  nome_socio: string
  cpf_cnpj_socio?: string
  qualificacao_socio?: string
}

function onlyDigits(value?: string) {
  return (value ?? '').replace(/\D/g, '')
}

export const ParceiroDetailStore = createSimpleStore(
  {
    parceiro: {} as ParceiroData,
    usuarios: [] as UsuarioVinculo[],
    qsaPrefill: [] as QsaMember[],
    documentMode: 'CNPJ' as 'CNPJ' | 'CPF',
    totals: { matriculas: 0, valorNewDriver: 0 as number | string },
    loading: false,
  },
  {
    fetchStarted(state) {
      state.loading = true
    },
    fetchParceiroSuccess(state, parceiro: ParceiroData) {
      state.parceiro = parceiro
      state.documentMode = onlyDigits(parceiro.cpfCnpj).length === 11 ? 'CPF' : 'CNPJ'
      state.loading = false
    },
    fetchUsuariosSuccess(state, usuarios: UsuarioVinculo[]) {
      state.usuarios = usuarios
    },
    fetchTotalsSuccess(state, totals: { matriculas: number; valorNewDriver: number | string }) {
      state.totals = totals
    },
    fetchError(state) {
      state.loading = false
    },
    setDocumentMode(state, mode: 'CNPJ' | 'CPF') {
      state.documentMode = mode
      if (mode === 'CPF') state.qsaPrefill = []
    },
    setQsaPrefill(state, qsa: QsaMember[]) {
      state.qsaPrefill = qsa
    },
    removeQsaMember(state, index: number) {
      state.qsaPrefill = state.qsaPrefill.filter((_, i) => i !== index)
    },
  },
  {
    thunks: {
      fetch(id: number) {
        return async (dispatch) => {
          dispatch(ParceiroDetailStore.actions.fetchStarted())
          try {
            const [parceiro, usuarios, vendas] = await Promise.all([
              getParceiro(id),
              listUsuariosParceiro(id),
              getVendas(id, { granularidade: 'mes' }),
            ])
            dispatch(ParceiroDetailStore.actions.fetchParceiroSuccess(parceiro))
            dispatch(ParceiroDetailStore.actions.fetchUsuariosSuccess(usuarios))
            dispatch(ParceiroDetailStore.actions.fetchTotalsSuccess(vendas.totals))
          } catch (err: any) {
            notification.error({
              message: err?.response?.data?.message ?? 'Erro ao carregar parceiro',
            })
            dispatch(ParceiroDetailStore.actions.fetchError())
          }
        }
      },
      refetchUsuarios(parceiroId: number) {
        return async (dispatch) => {
          try {
            const usuarios = await listUsuariosParceiro(parceiroId)
            dispatch(ParceiroDetailStore.actions.fetchUsuariosSuccess(usuarios))
          } catch {
            notification.error({ message: 'Erro ao atualizar usuários' })
          }
        }
      },
    },
  }
)
